var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.05 23.6833L15.5167 17.15C14.9333 17.6167 14.2625 17.9861 13.5042 18.2583C12.7458 18.5306 11.9389 18.6667 11.0833 18.6667C8.96389 18.6667 7.17033 17.9324 5.70267 16.464C4.235 14.9956 3.50078 13.202 3.5 11.0833C3.5 8.96389 4.23422 7.17033 5.70267 5.70267C7.17111 4.235 8.96467 3.50078 11.0833 3.5C13.2028 3.5 14.9963 4.23422 16.464 5.70267C17.9317 7.17111 18.6659 8.96467 18.6667 11.0833C18.6667 11.9389 18.5306 12.7458 18.2583 13.5042C17.9861 14.2625 17.6167 14.9333 17.15 15.5167L23.7125 22.0792C23.9264 22.2931 24.0333 22.5556 24.0333 22.8667C24.0333 23.1778 23.9167 23.45 23.6833 23.6833C23.4694 23.8972 23.1972 24.0042 22.8667 24.0042C22.5361 24.0042 22.2639 23.8972 22.05 23.6833ZM11.0833 16.3333C12.5417 16.3333 13.7814 15.8227 14.8027 14.8015C15.8239 13.7803 16.3341 12.5409 16.3333 11.0833C16.3333 9.625 15.8227 8.38522 14.8015 7.364C13.7803 6.34278 12.5409 5.83256 11.0833 5.83333C9.625 5.83333 8.38522 6.34394 7.364 7.36517C6.34278 8.38639 5.83256 9.62578 5.83333 11.0833C5.83333 12.5417 6.34394 13.7814 7.36517 14.8027C8.38639 15.8239 9.62578 16.3341 11.0833 16.3333Z",
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8d667ae50c41f811ed99dd708f0c84ad.svg";
export { ForwardRef as ReactComponent };